import { Skeleton } from "../../../../components/ui/skeleton";

export const CheckboxSkeleton = ({ count }) => {
  return (
    <div className="mx-4 mt-[9px] flex flex-col gap-[18px] ">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="flex gap-2 mb-[2.8px]">
          <Skeleton className="h-4 w-4 rounded-xl bg-primary/20 border border-primary/60" />
          <Skeleton className="h-4 w-24 rounded-xl bg-primary/20 border border-primary/60" />
        </div>
      ))}
    </div>
  );
};
